__turbopack_context__.v({
  "auto": "bPxgDq_auto",
  "blockquote": "bPxgDq_blockquote",
  "blockquoteAuthor": "bPxgDq_blockquoteAuthor",
  "container": "bPxgDq_container",
  "frameText": "bPxgDq_frameText",
  "image": "bPxgDq_image",
  "imageSource": "bPxgDq_imageSource",
  "imageWrap": "bPxgDq_imageWrap",
  "linkImage": "bPxgDq_linkImage",
  "table": "bPxgDq_table",
});
